import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { elakay_API } from "../../config";

// The "Dynamic" Publication Mode's human-facing route (spec §17, §20): a
// social crawler (Facebook/LinkedIn/X/WhatsApp/...) NEVER reaches this --
// server_elakay's own /elakay_api/marketing/:id serves it the real HTML
// directly (see server_elakay/elakay_routes/marketingPublic.js). Only an
// already-detected human browser is redirected here.
//
// Deliberately standalone -- NOT wrapped in the app's <Layout> (spec: "Le
// lien public ne doit PAS ouvrir le Dashboard... il doit ouvrir uniquement la
// page marketing publique") -- no header/nav/footer chrome, just the
// campaign page itself.
//
// Renders via an iframe pointed at the SAME backend endpoint the crawler
// gets, with `embed=1` (skips that endpoint's own bot-redirect branch, and
// adds `<base target="_top">` so a CTA click -- Shop Now/View Product/...
// -- navigates the real top-level tab, not the frame) -- this is a deliberate
// reuse of the exact same server-rendered HTML (resolveCampaignHtml, "ONE
// FINAL HTML"), not a second, independent client-side renderer.
const PublicMarketingPage = () => {
  const { campaignId } = useParams();
  const location = useLocation();
  const [title, setTitle] = useState("Elakay");

  useEffect(() => {
    let cancelled = false;
    fetch(`${elakay_API}/marketing/${campaignId}/meta`)
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled && data?.success && data.title) setTitle(data.title);
      })
      .catch(() => undefined);
    return () => { cancelled = true; };
  }, [campaignId]);

  useEffect(() => {
    document.title = title;
  }, [title]);

  const search = location.search ? `${location.search}&embed=1` : "?embed=1";
  const src = `${elakay_API}/marketing/${campaignId}${search}`;

  return (
    <iframe
      title={title}
      src={src}
      style={{ display: "block", width: "100%", height: "100vh", border: 0 }}
    />
  );
};

export default PublicMarketingPage;
